import { computed, onMounted, useStore, watch } from '@nuxtjs/composition-api'

export default function useDeviceHandler() {
  const store = useStore()

  const isMobile = computed(() => store.state.isMobile)

  watch(isMobile, () => {
    $('body').toggleClass('pc mobile')
  })

  onMounted(() => {
    $('body').addClass(!isMobile.value ? 'pc' : 'mobile')
  })
}
